import React from "react";

export const SupportersContext = React.createContext<{
  [hashtag: string]: { [answer: string]: string[] };
} | null>(null);
